export default {
      id: "desktop-only-usage",
      viewBox: "0 0 115 101",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#desktop-only",
      toString: function () {
        return this.url;
      }
    }